import styled from 'styled-components';

export const SBCFlex = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
